// Generated by CoffeeScript 2.7.0
var SerialNumberFieldMixin, VALIDATE_RULE_FIELDS;

import {
  SPELL_RULE_FIELDS
} from './constants.js';

VALIDATE_RULE_FIELDS = ['ProposeTime', 'Proposer', 'Field::RadioButton', 'Field::DateTime'];

export default SerialNumberFieldMixin = {
  data: function() {
    return {
      ruleCurrentGroups: [],
      formFieldGroups: [
        {
          options: _.map(this.field.settings.form_fields,
        function(field) {
            return {
              params: {
                field_id: field.id
              },
              label: field.title,
              type: field.type
            };
          })
        }
      ]
    };
  },
  created: function() {
    return this.ruleCurrentGroups = [
      {
        options: _.map(SPELL_RULE_FIELDS,
      (field) => {
          var option;
          option = {
            ...field,
            type: this.field.type
          };
          return option;
        })
      }
    ];
  },
  methods: {
    changeType: function(option) {
      var _option;
      if (VALIDATE_RULE_FIELDS.includes(option.type) && option.params) {
        if (option.type !== this.field.type) {
          this._updateType(option.type, option.params);
        }
        if (option.params.field_id !== this.field.settings.field_id) {
          this.field.settings.field_id = option.params.field_id;
          return this._updateType(option.type);
        }
      } else {
        if (option.type === this.field.type) {
          return;
        }
        if (option.type === 'FormFields') {
          _option = _.first(this.formFieldGroups[0].options);
          if (!_option) {
            return;
          }
          this.field.settings.field_id = _option.params.field_id;
          return this._updateType(_option.type, _option.params);
        } else {
          return this._updateType(option.type, option.params);
        }
      }
    }
  }
};
